import type { SortOrder } from "@/types";
import type { TopSellersFilterState } from "@/features/topsellers/types";

/** Швидка кнопка фільтра — перемикач для Sexual Content, Free тощо */
export type QuickFilter = {
  id: string;
  label: string;
  isActive: (state: TopSellersFilterState) => boolean;
  onToggle: (state: TopSellersFilterState) => TopSellersFilterState;
};

export type RankListType =
  | "topsellers"
  | "wishlist"
  | "followers"
  | "ccu"
  | "publishers"
  | "mlt"
  | "newtrending";

export type RankListConfig = {
  type: RankListType;
  tableName: string;
  historyTableName?: string;
  metadataKey?:
    | "total_topsellers_pages"
    | "total_wishlist_pages"
    | "total_followers_pages"
    | "total_ccu_pages";
  primaryColor: string;
  displayName: string;
};

export const RANK_LIST_CONFIGS: Record<RankListType, RankListConfig> = {
  topsellers: {
    type: "topsellers",
    tableName: "steam_topsellers_full",
    historyTableName: "steam_topsellers_history",
    metadataKey: "total_topsellers_pages",
    primaryColor: "#66c0f4",
    displayName: "Top Sellers",
  },
  wishlist: {
    type: "wishlist",
    tableName: "steam_wishlist_full",
    historyTableName: "steam_wishlist_history",
    metadataKey: "total_wishlist_pages",
    primaryColor: "#66c0f4",
    displayName: "Top Wishlist",
  },
  followers: {
    type: "followers",
    tableName: "steam_followers_full",
    historyTableName: "steam_followers_history",
    metadataKey: "total_followers_pages",
    primaryColor: "#66c0f4",
    displayName: "Top Followers",
  },
  ccu: {
    type: "ccu",
    tableName: "steam_ccu_current_full",
    historyTableName: "steam_ccu_history",
    metadataKey: "total_ccu_pages",
    primaryColor: "#a4d007",
    displayName: "Current Online",
  },
  publishers: {
    type: "publishers",
    tableName: "steam_curators_full",
    primaryColor: "#66c0f4",
    displayName: "Top Publishers",
  },
  mlt: {
    type: "mlt",
    tableName: "steam_mlt_full",
    historyTableName: "steam_mlt_history",
    primaryColor: "#66c0f4",
    displayName: "More Like This",
  },
  // New & Trending is per-country only (no global list). The raw read path and
  // the dedicated get_newtrending_history_bucketed RPC both target the region
  // table; historyTableName is set only to satisfy the config guard.
  newtrending: {
    type: "newtrending",
    tableName: "steam_newtrending_current_region",
    historyTableName: "steam_newtrending_history_region",
    primaryColor: "#e35e1c",
    displayName: "New & Trending",
  },
};

export type FetchRankListParams = {
  type: RankListType;
  page: number;
  pageSize: number;
  sort: SortOrder | string | null;
  skipTotalCount: boolean;
  /**
   * Optional region code (cc). Used only for rank lists that support regions
   * (currently: topsellers). Use "global" or omit for global.
   */
  cc?: string;
};

export type SortConfig = {
  sortColumn: string;
  ascending: boolean;
  effectiveSort: string;
};
